import { z } from 'zod';

export const contentStatusTableSchema = z.object({
  type: z.literal('contentStatus'),
  data: z.array(
    z.object({
      student: z.object({
        id: z.string(),
        lastName: z.string(),
        firstName: z.string(),
      }),
      status: z.enum(['COMPLETE', 'IN_PROGRESS', 'NOT_STARTED']),
    })
  ),
});

export type ContentStatusTableResponse = z.infer<
  typeof contentStatusTableSchema
>;
